import { queryKeys } from 'api/consts'
import { queryClient } from 'contexts/reactQuery'

import { OnboardingTipResponse, OnboardingTipsResponse } from './types'

export const addNewUserTipsQueryClient = (tip: OnboardingTipResponse) =>
  queryClient.setQueryData<OnboardingTipsResponse>(
    [queryKeys.onboardingTips],
    tips => ({
      onboardingTips:
        tips?.onboardingTips?.filter(
          cachedTip => cachedTip.slug !== tip.slug,
        ) || [],
    }),
  )
